import React, {useState, useCallback} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container, Row, Col} from '@modifi/ui'

import {DefaultComponentWrapper, StyledTabsPure, StyledH4} from '../common'
import ContactCard from './ContactCard'
import {TabsCol} from './styles'

const propTypes = {
  'tab-1': PropTypes.string.isRequired,
  'tab-2': PropTypes.string,
  'tab-3': PropTypes.string,
  'tab-4': PropTypes.string,
  'tab-5': PropTypes.string,
  'tab-6': PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      tab: PropTypes.oneOf(['tab-1', 'tab-2', 'tab-3', 'tab-4', 'tab-5', 'tab-6']),
      location: PropTypes.string.isRequired,
      locationNameForAnalytics: PropTypes.string,
      address: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      whatsappNumber: PropTypes.string,
      additionalInfo: PropTypes.string,
      timeZone: PropTypes.string,
      topCtaLabel: PropTypes.string,
      topCtaType: PropTypes.string,
      topCtaUrl: PropTypes.string,
      bottomCtaLabel: PropTypes.string,
      bottomCtaUrl: PropTypes.string,
      bottomCtaType: PropTypes.string,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  'tab-2': undefined,
  'tab-3': undefined,
  'tab-4': undefined,
  'tab-5': undefined,
  'tab-6': undefined,
  backgroundColor: undefined,
}

type TabItemType = {
  label: string
  key: string
  disabled: boolean
}

export type ContactDetailsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const ContactDetails: React.FC<ContactDetailsProps> = props => {
  const {
    'tab-1': tab1Label,
    'tab-2': tab2Label,
    'tab-3': tab3Label,
    'tab-4': tab4Label,
    'tab-5': tab5Label,
    'tab-6': tab6Label,
    cards,
    backgroundColor,
  } = props

  const tabItems = [tab1Label, tab2Label, tab3Label, tab4Label, tab5Label, tab6Label].reduce(
    (final, item, index) => {
      if (item) {
        final.push({label: item!, key: `tab-${index + 1}`, disabled: false})
      }
      return final
    },
    [] as TabItemType[]
  ) as TabItemType[]

  const [selectedTab, setSelectedTab] = useState(tabItems?.[0]?.key)

  const handleTabClick = useCallback((val: any, key: any): void => setSelectedTab(key), [])

  const selectedCardItems = cards?.filter(card => card?.tab === selectedTab)

  return (
    <DefaultComponentWrapper backgroundColor={backgroundColor}>
      <Container>
        <Row justifyContent="center">
          <TabsCol col={12} md="auto">
            {tabItems.length > 1 ? (
              <StyledTabsPure
                options={tabItems}
                activeTab={selectedTab}
                // @ts-expect-error to be fixed
                theme="primary"
                transparent
                onTabClick={handleTabClick}
                collapse
              />
            ) : (
              <StyledH4>{tabItems?.[0]?.label}</StyledH4>
            )}
          </TabsCol>
        </Row>
        <Row mt={56}>
          {selectedCardItems?.map(card => (
            <Col col={8} sm={6} md={4} mb={40} key={card?.location}>
              <ContactCard cardDetails={card!} />
            </Col>
          ))}
        </Row>
      </Container>
    </DefaultComponentWrapper>
  )
}

ContactDetails.propTypes = propTypes

ContactDetails.defaultProps = defaultProps

export default ContactDetails
